const numberRegex = new RegExp(/[0-9]/)

export const regexNumericalTest = (value) => numberRegex.test(value)
